var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 15,
    viewBox: "0 0 19 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5225 0.643555H1.77246C1.47409 0.643555 1.18794 0.762081 0.976966 0.97306C0.765987 1.18404 0.647461 1.47019 0.647461 1.76855V13.0186C0.647461 13.3169 0.765987 13.6031 0.976966 13.814C1.18794 14.025 1.47409 14.1436 1.77246 14.1436H17.5225C17.8208 14.1436 18.107 14.025 18.318 13.814C18.5289 13.6031 18.6475 13.3169 18.6475 13.0186V1.76855C18.6475 1.47019 18.5289 1.18404 18.318 0.97306C18.107 0.762081 17.8208 0.643555 17.5225 0.643555ZM16.6562 13.0186H2.70621L6.64371 8.94605L5.83371 8.16418L1.77246 12.3661V2.62355L8.76434 9.58168C8.97512 9.79121 9.26025 9.90882 9.55746 9.90882C9.85467 9.90882 10.1398 9.79121 10.3506 9.58168L17.5225 2.44918V12.2929L13.3825 8.15293L12.5893 8.94605L16.6562 13.0186ZM2.50934 1.76855H16.6112L9.55746 8.78293L2.50934 1.76855Z",
    fill: "#717171"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.005bd76337f1e00a6ba8f2f069efdb45.svg";
export { ForwardRef as ReactComponent };